import { jsx } from "react/jsx-runtime";
import MuiCheckbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { fieldToCheckbox } from "./Checkbox.js";
function CheckboxWithLabel({ Label, ...props }) {
  return /* @__PURE__ */ jsx(
    FormControlLabel,
    {
      control: /* @__PURE__ */ jsx(MuiCheckbox, { ...fieldToCheckbox(props) }),
      ...Label
    }
  );
}
CheckboxWithLabel.displayName = "FormikMaterialUICheckboxWithLabel";
export {
  CheckboxWithLabel
};
//# sourceMappingURL=CheckboxWithLabel.js.map
